module.exports = __webpack_public_path__ + "img/agreement_btn.0105bbbb.png";